import React from 'react';
import { BRAND } from '../../../constants/main';
import { StockSliceStyledAC } from './AC/StockSliceStyled.AC';
import { StockSliceStyledAP } from './AP/StockSliceStyled.AP';
import { StockSliceStyledDS } from './DS/StockSliceStyled.DS';
import { StockSliceStyledOV } from './OV/StockSliceStyled.OV';
import { StockSliceStyled } from './StockSliceStyled';

import { SC } from '../../../styles/theme';
import { BrandTypes } from '../../../types/brands';

export const MAX_STOCK_SLICE_PODS_COUNT = 3;

export type StockSliceProps = SC & { normalizeEnabled?: boolean };

const StockSlice = (props: StockSliceProps) => {
    if (BRAND === BrandTypes.AC) return <StockSliceStyledAC {...props} />;
    if (BRAND === BrandTypes.OV) return <StockSliceStyledOV {...props} />;
    if (BRAND === BrandTypes.AP) return <StockSliceStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockSliceStyledDS {...props} />;
    return <StockSliceStyled {...props} />;
};

export default StockSlice;
